import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Reusable Sidebar
 * Props:
 *   logo: string | ReactNode
 *   title: string
 *   navItems: Array<{ label, path, icon: ReactNode, end?: boolean }>
 *   footer?: ReactNode
 */
export default function Sidebar({ logo, title, navItems = [], footer }) {
  return (
    <aside className="w-64 min-h-screen bg-white border-r border-slate-100 flex flex-col shadow-sm">
      {/* Logo / Brand */}
      <div className="flex items-center gap-3 px-5 py-5 border-b border-slate-100">
        {logo && <span className="text-primary-600 text-2xl">{logo}</span>}
        <span className="font-display font-bold text-slate-900 text-lg leading-tight">
          {title}
        </span>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? "active" : ""}`
            }
          >
            {item.icon && (
              <span className="w-5 h-5 flex-shrink-0">{item.icon}</span>
            )}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer slot */}
      {footer && (
        <div className="px-3 py-4 border-t border-slate-100">{footer}</div>
      )}
    </aside>
  );
}
